module.exports = __webpack_public_path__ + "img/pcb_10.d924eb30.png";